import React from 'react';
import styles from './style.module.css';

const Checkbox = ({ checked, label, handleChange, name, children }) => {
  return (
    <div className={styles.wrapper}>
      <div className={`coop-form__row ${styles.customRow}`}>
        <div className="coop-form__choice">
          <input
            type="checkbox"
            name={name}
            id={name}
            onChange={handleChange}
            checked={checked}
            className={`coop-form__field coop-form__checkbox ${styles.customRow__input}`}
          />
          <label htmlFor={name} className={`${styles.customRow__choice} coop-form__label`} />
        </div>
      </div>
      <div className={styles.textContainer}>{children}</div>
    </div>
  );
};

export default Checkbox;
